import { i as r } from "./is-object.js";
var i = Math.floor,
  e = Number.isInteger || function (e) {
    return !r(e) && isFinite(e) && i(e) === e;
  };
export { e as i };